import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import config from '@/config';
import ProfileDataContext from '@/context/ProfileDataContext';
import useCache from '@/hooks/useCache';
import ProfileAddButton from '@/shared-components/buttons/components/ProfileAddButton';
import ProfileContentLoader from '@/shared-components/loader/special-loaders/ProfileContentLoader';
import Text from '@/shared-components/text/components/Text';

import PopUpCreateOptions from '../drafts/components/PopUpCreateOptions';
import PopUpDrafts from '../drafts/components/PopUpDrafts';
import MetaDescripProfilePages from '../MetaDescripProfilePages';
import ProfilePostDrafts from '../posts-drafts';

import PostsVirtualList from './components/PostsVirtualList';

import './index.css';

export default function ProfileBoard() {
  const { profileData, internal } = useContext(ProfileDataContext);
  const navigate = useNavigate();

  const { loading, fetchData, loadMoreData } = useCache(
    `${profileData._id}_posts`,
    `${config.apis.api.url}/posts/gallery/${profileData._id}`,
    {
      injectToken: true,
      invalidateWhen: internal
        ? ["SUBMIT_POST", "DELETE_POST", `${profileData._id}_REFRESH`]
        : [`${profileData._id}_REFRESH`],
    }
  );

  const defaultPopUpValue = false;
  const [openOptions, setOpenOptions] = useState(defaultPopUpValue);
  const [openDraftPopup, setOpenDraftPopup] = useState(false);

  return (
    <>
      <MetaDescripProfilePages fetchData={profileData} subPage="board" />

      {internal && (
        <>
          <ProfileAddButton
            onClick={() =>
              profileData?.post_draft_count === 0
                ? navigate("/profile/add-post")
                : setOpenOptions(!openOptions)
            }
          />
          <PopUpCreateOptions
            open={openOptions}
            close={() => setOpenOptions(defaultPopUpValue)}
            openDraftPopup={setOpenDraftPopup}
            textOption="Post"
            to="/profile/add-post"
          />
          <PopUpDrafts
            open={openDraftPopup}
            close={() => {
              setOpenDraftPopup(false);
            }}
            DraftsList={ProfilePostDrafts}
          />
        </>
      )}

      {loading ? (
        <div className="profile-board-loader-container">
          <ProfileContentLoader />
        </div>
      ) : fetchData.data.length === 0 ? (
        <Text className="user-profile__board-empty-view" paragraph small>
          {internal
            ? "This is your personal space. Inform the community about your upcoming exhibitions, artists, and gallery news"
            : "The gallery hasn't shared any posts yet. Stay tuned for updates and future artistic creations"}
        </Text>
      ) : (
        <PostsVirtualList items={fetchData} onLoadMore={loadMoreData} />
      )}
    </>
  );
}
